// extracted by mini-css-extract-plugin
export default {"container":"WhiteLabel-module__container--cObbG","white-label":"WhiteLabel-module__white-label--2EkVd"};